export default __webpack_public_path__ + "static/media/hollowTrashcan.018eb448.svg";